<template>
  <section id="two">
    <h2>abroad</h2>
    <div class="row">
      <article
        class="6u 12u$(xsmall) work-item"
        v-for="entry in entries"
        v-bind:entry="entry"
        v-bind:key="entry.id"
      >
        <img :src="entry.image_source" class="image fit" />
        <h3>{{entry.headline}}</h3>
        <p>
          <span v-html="entry.text"></span>
        </p>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  data: function() {
    return {
      entries: [
        {
          id: 1,
          image_source: "images/australia.jpg",
          headline: "[2017] Australia - Study Abroad",
          text:
            'During my master studies, i had the opportunity to study for one semester at <a href="https://www.mq.edu.au" target="_blank">Macquarie University</a> in Sydney, Australia. <a href="https://aus.tobiasruby.de" target="_blank">see more.</a>'
        },
        {
          id: 2,
          image_source: "images/transsib.jpg",
          headline: "[2016] TRANSSIB and the far east",
          text:
            'After the bachelor thesis has been done, i travelled along the historic transsiberian railway up to vladivostok and explored meanwhile the far east. <a href="https://transsib.tobiasruby.de" target="_blank">see more.</a>'
        },
        {
          id: 3,
          image_source: "images/tanzania.png",
          headline: "[2013] Tanzania",
          text:
            'In cooperation with <a href="www.amani-kinderdorf.de" href="_blank">Amani-Kinderdorf e.V.</a> and supported by the "weltwärts" program, i was working as a computer studies teacher for 13 months at Pandahill-Secondary-School near Mbeya. <a href="https://tz.tobiasruby.de" target="_blank">see more.</a>'
        }
      ]
    };
  }
};
</script>